import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import "./src/index.css";

const queryClient = new QueryClient();

export const onClientEntry: GatsbyBrowser["onClientEntry"] = async () => {
  try {
    const { default: Tracker } = await import("@openreplay/tracker");
    const { default: trackerAssist } = await import(
      "@openreplay/tracker-assist"
    );

    const tracker = new Tracker({
      projectKey: "shbwikqbQ6FhL1TcGS88",
      ingestPoint: "https://t.samius.co/ingest",
      __DISABLE_SECURE_MODE: process.env.NODE_ENV === "development",
    });
    tracker.use(trackerAssist());
    await tracker.start();
    // Expose so the onboarding wizard can capture waitlist signups as
    // OpenReplay events (each tied to its session replay — useful for
    // seeing where people drop off). See Onboarding.tsx handleFinish.
    (window as unknown as { __orTracker?: unknown }).__orTracker = tracker;
  } catch (e) {
    // Tracker may fail in dev or when doNotTrack is active
  }
};

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>{element}</TooltipProvider>
  </QueryClientProvider>
);

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => (
  <>
    {element}
    <Toaster />
    <Sonner />
  </>
);
